import contains from 'ramda/src/contains'

export default (state, { href = '', target }) => target || (contains('http', href) ? '_blank' : '_self')
